import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    etiqueta_updateStore({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'etiqueta/update-store', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    etiqueta_get() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'etiqueta/get')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    etiqueta_setMono({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'etiqueta/set-mono', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    etiqueta_delete({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'etiqueta/delete', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};